import { InputWrapError } from '../../Input'
import { WysiwygEditor } from '../../WysiwygEditor'

import { isFormFieldWysiwygErrorShown } from './FormFieldWysiwyg.utils'

import * as styles from './FormFieldWysiwyg.module.css'

function FormFieldWysiwyg({ blocked, disabled, error, ...editorProps }) {
  const hasErrorText = isFormFieldWysiwygErrorShown({
    blocked,
    disabled,
    error,
  })

  return (
    <div className={styles.editorWrapper}>
      <WysiwygEditor
        {...editorProps}
        blocked={blocked}
        disabled={disabled}
        error={error}
      />
      {hasErrorText ? <InputWrapError text={error} /> : null}
    </div>
  )
}

export default FormFieldWysiwyg
